import { z } from 'zod';
export const livenessSchema = z.object({
    status: z.literal('ok'),
    uptime_s: z.number(),
});
export const dependencyStatusSchema = z.object({
    name: z.string(),
    status: z.enum(['up', 'down']),
    duration_ms: z.number(),
    error: z.string().optional(),
});
export const readinessSchema = z.object({
    status: z.enum(['ready', 'not_ready']),
    dependencies: z.array(dependencyStatusSchema),
});
//# sourceMappingURL=health.js.map